import {
  LOAD_USER_PROPERTIES,
  RESET_USER_PROPERTIES,
  SET_USER_PROPERTY,
} from './constants';

export function loadUserProperties(userProperties) {
  return { type: LOAD_USER_PROPERTIES, payload: { userProperties } };
}

export function setUserProperty(key, value) {
  return { type: SET_USER_PROPERTY, payload: { key, value } };
}

export function resetUserProperties() {
  return { type: RESET_USER_PROPERTIES };
}
